module.exports = __webpack_public_path__ + "static/assets/adbd5696fc8e66dcfb15fb9b6b37ecfe.svg";